export const video = {
  name: "video" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="currentColor"><path fill-rule="evenodd" d="M1.6 6a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 .9.9v14a.9.9 0 0 1-.9.9h-19a.9.9 0 0 1-.9-.9V6Zm1.8.9v12.2h17.2V6.9H3.4Zm6.167 1.811a.9.9 0 0 1 .916.03l5.5 3.5a.9.9 0 0 1 0 1.518l-5.5 3.5A.9.9 0 0 1 9.1 16.5v-7a.9.9 0 0 1 .467-.789ZM10.9 11.14v3.722L13.824 13 10.9 11.14Z" clip-rule="evenodd"/></svg>`,
  keywords: ["video"],
  category: "media" as const,
};
